import React from 'react';
import Button from './Button';

const WhiteButton: React.FC<React.LinkHTMLAttributes<HTMLLinkElement>> = props => {
	return <Button {...props} className="button-white" />;
};

export default WhiteButton;
